const nextArrow = `<button is="next-button" class="next circle-button ring group">
        <span class="sr-only">Vor</span>
        <span class="animated-arrow"></span>
      </button>`;
const prevArrow = `<button is="prev-button" class="prev circle-button ring group">
        <span class="sr-only">Zurück</span>
        <span class="animated-arrow animated-arrow--reverse"></span>
      </button>`;

const mobile_nextArrow = `<span class="next circle-chevron group-hover:colors"><svg role="presentation" focusable="false" width="5" height="8" class="icon icon-chevron-right-small reverse-icon" viewBox="0 0 5 8">
        <path d="m.75 7 3-3-3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
      </svg></span>`;
const mobile_prevArrow = `<span class="prev circle-chevron group-hover:colors"><svg role="presentation" focusable="false" width="5" height="8" class="icon icon-chevron-right-small reverse-icon" viewBox="0 0 5 8">
        <path d="m.75 7 3-3-3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
      </svg></span>`;

$(document).ready(function () {
    $(".video-slick-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      prevArrow,
      nextArrow,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "0px",
            prevArrow: mobile_prevArrow,
            nextArrow: mobile_nextArrow,
          },
        },
      ],
    });
});



const videos_container = document.querySelectorAll('.video-carousel .video-card');


videos_container.forEach(item => {
  item.addEventListener('click', () => {
    const video = item.querySelector("video");
    if(video){
    if (video.paused) {
      video.classList.add("active_video_play");
      video.play();
    } else {
      video.pause();
      video.classList.remove("active_video_play");
    } 
    }
  });
});

